var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadphoneHex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 82,
    viewBox: "0 0 73 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.3433,
    y: 75.4365,
    width: 18.1731,
    height: 6.04506,
    rx: 3.02253,
    fill: "#E7AB12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.6284,
    y: 75.4365,
    width: 18.173,
    height: 6.04506,
    rx: 3.02253,
    fill: "#E7AB12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72368 46.2792C5.68261 44.442 5.68261 42.1932 6.72368 40.3561L19.0361 18.6292C20.1027 16.7471 22.0988 15.5839 24.2621 15.5839L48.6944 15.5839C50.8577 15.5839 52.8539 16.7471 53.9204 18.6292L66.2328 40.3561C67.2739 42.1932 67.2739 44.442 66.2328 46.2792L53.9204 68.0061C52.8539 69.8882 50.8577 71.0514 48.6944 71.0514H24.2621C22.0988 71.0514 20.1027 69.8882 19.0361 68.0061L6.72368 46.2792Z",
    fill: "#FAB70C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4827 50.4858C43.4745 50.4858 49.1426 44.7039 49.1426 37.5715C49.1426 30.4391 43.4745 24.6572 36.4827 24.6572C29.4908 24.6572 23.8228 30.4391 23.8228 37.5715C23.8228 44.7039 29.4908 50.4858 36.4827 50.4858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6666 43.2408C37.1734 43.2408 40.0162 40.3769 40.0162 36.8441C40.0162 33.3112 37.1734 30.4473 33.6666 30.4473C30.1597 30.4473 27.3169 33.3112 27.3169 36.8441C27.3169 40.3769 30.1597 43.2408 33.6666 43.2408Z",
    fill: "#570029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9556 18.4829C57.3138 16.5065 61.5913 17.6538 63.5097 21.0455L69.1712 31.0547C71.0896 34.4464 69.9224 38.7981 66.5642 40.7745L53.9556 18.4829Z",
    fill: "#F9858E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9316 18.4351C15.5734 16.4587 11.2959 17.6059 9.37748 20.9976L3.716 31.0068C1.79758 34.3985 2.96476 38.7502 6.32296 40.7266L18.9316 18.4351Z",
    fill: "#F9858E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2529 19.4699C63.6552 18.6446 65.4414 19.1237 66.2425 20.54L71.1235 29.1694C71.9246 30.5857 71.4372 32.4028 70.0349 33.2281L62.2529 19.4699Z",
    fill: "#F9858E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6338 19.4211C9.2315 18.5958 7.44533 19.0749 6.64426 20.4911L1.76323 29.1206C0.962155 30.5368 1.44953 32.354 2.85182 33.1793L10.6338 19.4211Z",
    fill: "#F9858E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0693 25.1021C60.0693 13.2935 49.4139 3.7207 36.2697 3.7207C23.1256 3.7207 12.4702 13.2935 12.4702 25.1021",
    stroke: "#F9858E",
    strokeWidth: 5.59125
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphoneHex);
export default __webpack_public_path__ + "static/media/headphone-hex.e25021a7e654ea610e400106b5555302.svg";
export { ForwardRef as ReactComponent };